<template>
  <div
    ref="content"
    class="finalize-colorup-review h-auto"
    :class="{ customizer: fromCustomizer }"
  >
    <main ref="mainProduct" class="main-content-product" style="z-index: 99;">
      <ContentColorUpReview
        ref="topContentColorUpReview"
        v-if="dataLoaded === true"
        v-bind="mainProductProps"
        :top-right-padding="fromCustomizer ? 80 : 0"
        @onThumbsLoaded="onThumbsLoaded(1)"
      >
        <template v-slot:contentTopRight>
          <slot name="contentTopRight" />

          <div
            v-if="showButtons"
            ref="headerButtons"
            class="header-buttons position-fixed pt-4 pb-3"
          >
            <ApproveButtons
              :id="id"
              :order-id="orderId"
              :on-approve="onApprove"
              :on-download="downloadPDFWithCSS"
              :pdf-link="pdfLink"
              width-approve-buttons="70%"
            />
          </div>
        </template>
      </ContentColorUpReview>
    </main>

    <main ref="pairProduct" v-if="hasPairProduct">
      <ContentColorUpReview
        ref="bottomContentColorUpReview"
        v-if="dataLoaded === true"
        v-bind="pairProductProps"
        @onThumbsLoaded="onThumbsLoaded(2)"
      />
    </main>

    <!--******************* PDF *******************-->
    <div class="position-fixed w-100" v-if="printPDF === true">
      <!-- <div> -->
      <ContentColorUpReview
        ref="viewPDFMainProduct"
        v-if="dataLoaded === true"
        v-bind="mainProductProps"
        :format-pdf="true"
      />

      <ContentColorUpReview
        ref="viewPDFPairProduct"
        v-if="hasPairProduct && dataLoaded === true"
        v-bind="pairProductProps"
        :format-pdf="true"
      />
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import ThreeCols from './ThreeCols'
import { namespace } from 'vuex-class'
// import ProductView from '@/views/frontend/ProductView'
// import { groupBy as _groupBy } from 'lodash'
import JsPdf from 'jspdf'
// import html2pdf from 'html2pdf.js'
import html2canvas from 'html2canvas'

import productService from '@/services/ProductService'

import ContentColorUpReview from '@/components/Front/finalize/ContentColorUpReview'
import InfoColorUpReview from '@/components/Front/finalize/InfoColorUpReview'
import ThumbsColorUpReview from '@/components/Front/finalize/ThumbsColorUpReview'
import { faFilePdf, faDownload } from '@fortawesome/free-solid-svg-icons'
import ApproveButtons from '@/components/Front/finalize/ApproveButtons'

const appUIModule = namespace('appUI')
const menuItemsStore = namespace('menuItems')
const userStore = namespace('userStore')
const manageUserStore = namespace('manageUserStore')
const base64Img = require('base64-img')
const materialModule = namespace('material')
// window.html2canvas = html2canvas

@Component({
  // extends: ProductView,
  components: {
    ThreeCols,
    ContentColorUpReview,
    InfoColorUpReview,
    ThumbsColorUpReview,
    ApproveButtons
  }
})
export default class FinalizeColorUpReview extends Vue {
  @Prop({
    type: String,
    required: true,
    default: null
  })
  id

  @Prop({
    type: String,
    required: false,
    default: null
  })
  orderId

  @Prop({
    type: Boolean,
    default: true
  })
  showButtons

  @Prop({
    type: Boolean,
    required: false,
    default: false
  })
  executeInBatch

  @Prop({
    type: Boolean,
    required: false,
    default: false
  })
  fromOrderReview

  @Prop({
    type: Boolean,
    required: false,
    default: false
  })
  fromCustomizer

  doc = null

  icons = {
    faFilePdf,
    faDownload
  }

  printPDF = false
  pdfLink = null
  infoMainProduct = {}
  infoPairProduct = {}

  dataLoaded = false
  currentUserDetail = {}
  thumbsMainLoaded = false
  thumbsPairLoaded = false

  @appUIModule.Action('setForceHideLoader') actionSetForceHideLoader
  @menuItemsStore.Action('fetchMenuItems') actionFetchMenuItems
  @menuItemsStore.Action('menuItems') stateMenuItems
  // @userStore.Action('updateDesign') actionUpdateDesign
  @userStore.Getter('readDesignData') getterDesignData
  @userStore.Mutation('SET_READ_DESIGN_DATA') mutationSetReadDesignData
  @userStore.Getter('designPairProductId') getterDesignPairProductId

  // @manageUserStore.State('userDetail') currentUserDetail
  @manageUserStore.Action('getUser') actionGetUser

  @materialModule.Action('fetchMaterials') actionFetchMaterials
  @materialModule.State('materials') stateMaterials

  beforeDestroy() {
    this.unBindEvents()
  }

  unBindEvents() {
    this.$eventHub.$off('generateColorUpPdf', this.generateColorUpPdf)
    this.$eventHub.$off('pendingColorUpPdf', this.pendingColorUpPdf)
    this.$eventHub.$off(
      'designThumbnailsPDFCreated',
      this.designThumbnailsPDFCreated
    )
  }

  created() {
    this.unBindEvents()
    this.$eventHub.$on('generateColorUpPdf', this.generateColorUpPdf)
    this.$eventHub.$on('pendingColorUpPdf', this.pendingColorUpPdf)
    this.$eventHub.$on(
      'designThumbnailsPDFCreated',
      this.designThumbnailsPDFCreated
    )

    this.getData()
    this.actionFetchTextTypes()
  }

  pendingColorUpPdf() {
    this.pdfLink = null
  }

  designThumbnailsPDFCreated() {
    // this.actionSetPreventHideLoader(false)
    // this.hideLoading()
    this.$refs.topContentColorUpReview.endRefreshContent()
    this.$refs.bottomContentColorUpReview &&
      this.$refs.bottomContentColorUpReview.endRefreshContent()
  }

  startUpdatingContent() {
    // this.actionSetPreventShowLoader(false)
    // this.actionExecuteInBackground(false)
    // this.actionSetPreventHideLoader(true)
    // this.showLoading()
    this.$refs.topContentColorUpReview.startRefreshContent()
    this.$refs.bottomContentColorUpReview &&
      this.$refs.bottomContentColorUpReview.startRefreshContent()
  }

  generateColorUpPdf(forceBuildPdf, callback = null) {
    this.pdfLink = null
    if (this.executeInBatch) {
      this.actionSetPreventShowLoader(true)
    }
    this.getData(forceBuildPdf)

    this.createColorUpPdf(forceBuildPdf).then(() => {
      if (callback) {
        callback()
      }
    })
  }

  createColorUpPdf(forceBuildPdf = false) {
    return new Promise((resolve, reject) => {
      this.waitForDownload().then(() => {
        // console.log('this.getterDesignData', this.getterDesignData)
        // if (
        //   !this._get(this.getterDesignData, 'pdfs.col', false) ||
        //   forceBuildPdf
        // ) {
        //   this.printPDF = true
        //   setTimeout(() => {
        //     this.downloadPDFWithCSS(false).then(doc => {
        //       if (doc === false) {
        //         return
        //       }
        //       // this.$emit('onUpdateFileContent', doc.output('blob'))
        //       const config = {
        //         headers: {
        //           'Content-Type': 'multipart/form-data'
        //         }
        //       }
        //       const designSerial = this._get(this.getterDesignData, 'serial')
        //       const data = new FormData()
        //       data.append('fixedFileName', true)
        //       data.append('uploadingColorUp', true)
        //       data.append(
        //         this.orderId ? 'colorUpPDF' : 'colorUpPdf',
        //         this.getFile(
        //           doc.output('blob'),
        //           `colorup_est_${this.dateFile}_${this.id}${designSerial}.pdf`,
        //           'pdf'
        //         )
        //       )

        //       if (this.orderId) {
        //         // saving order
        //         this.$bbApi
        //           .patch(`orders/${this.orderId}`, data, config)
        //           .then(res => {
        //             this.pdfLink = this._get(res, 'data.design.pdfs.col')
        //           })
        //       } else {
        //         // saving design
        //         this.$bbApi
        //           .patch(`designs/${this.id}`, data, config)
        //           .then(res => {
        //             this.pdfLink = this._get(res, 'data.pdfs.col')
        //           })
        //       }

        //       resolve()
        //     })
        //   })
        // } else {
        this.pdfLink = this._get(this.getterDesignData, 'pdfs.col')
        resolve()
        // }
      })
    })
  }

  onThumbsLoaded(type) {
    if (type === 1) {
      this.thumbsMainLoaded = true
    } else if (type === 2) {
      this.thumbsPairLoaded = true
    }

    if (!this.hasPairProduct) {
      this.thumbsPairLoaded = true
    }
  }

  waitForDownload() {
    return new Promise((resolve, reject) => {
      const interval = setInterval(() => {
        if (this.isAlreadyForDownload === true) {
          clearTimeout(interval)
          resolve()
        }
      }, 500)
    })
  }

  get isAlreadyForDownload() {
    return this.dataLoaded && this.thumbsLoaded
  }

  get thumbsLoaded() {
    return this.thumbsMainLoaded && this.thumbsPairLoaded
  }

  get dateFile() {
    const dateFormatted = Vue.filter('dateFormat')(
      new Date(this.getterDesignData.createdAt),
      'MMDDYYYY'
    )

    return dateFormatted || ''
  }

  getData(forceBuildPdf = false) {
    if (
      !(Array.isArray(this.stateMaterials) && this.stateMaterials.length > 0)
    ) {
      this.actionFetchMaterials({
        params: {
          _fields: 'name',
          // _filter: [
          //   {
          //     field: 'isPublished',
          //     op: '=',
          //     val: true
          //   },
          //   {
          //     field: 'isDeleted',
          //     op: '=',
          //     val: false
          //   }
          // ],
          _limit: 0
        }
      })
    }

    const orderId = this.orderId || false
    const queryId = this.id

    if (!this.fromOrderReview) {
      if (!this.getterDesignAlreadyDefined) {
        this.mutationSetReadDesignData()
      }
    }

    let needsSetDesignData = false
    let promise

    if (this.getterDesignAlreadyDefined) {
      promise = Promise.resolve(this.getterDesignData)
    } else {
      promise = this.actionReadDesign({
        designId: queryId,
        orderId: orderId
      })
      needsSetDesignData = true
    }

    let designData
    let paramsInfoProduct

    return promise
      .then(designDataResponse => {
        designData = designDataResponse
        if (orderId) {
          this.actionSetOrderId(orderId)
        }
        this.actionSetDesignId(queryId)
        this.actionSetDesignName(designData.name)
        this.actionSetDesignRosterId(designData.roster)
        this.actionSetDesignRosterName(designData.rosterName)
        this.actionSetDesignRosterPairId(designData.rosterPair)
        this.actionSetDesignRosterPairName(designData.rosterPairName)
        this.actionSetDesignUserId(designData.user)
        this.actionSetDesignTeamName(designData.teamName)
        // this.hideLoading()
        this.actionGetUser({
          id: designData.user,
          config: {
            noset: true,
            params: {
              _fields:
                'firstName,lastName,email,phone,city,state,zip,address1,address2,organization.organizationName,' +
                'organization.organizationName,organization.shippingAddresses'
            }
          }
        }).then(userInfo => {
          if (userInfo) {
            this.currentUserDetail = userInfo
          }
        })

        this.dataLoaded = true
        this.setDimensions()

        paramsInfoProduct = {
          _fields: 'styleName,styleNumber'
        }
        return productService.getItem(designData.product, {
          params: paramsInfoProduct
        })
      })
      .then(response => {
        if (response && response.data) {
          this.infoMainProduct = response.data

          if (designData.styleNumbers) {
            let savedStyleNumber = designData.styleNumbers.find(
              x => x.id.toString() === this.infoMainProduct._id
            )
            if (savedStyleNumber) {
              this.infoMainProduct.styleNumber = savedStyleNumber.styleNumber
            }
          }
        }

        this.resetLoader()

        let promise = Promise.resolve(false)
        if (this.getterDesignPairProductId) {
          promise = productService
            .getItem(this.getterDesignPairProductId, {
              params: paramsInfoProduct
            })
            .then(response => {
              this.infoPairProduct = response.data

              if (designData.styleNumbers) {
                let savedStyleNumber = designData.styleNumbers.find(
                  x => x.id.toString() === this.infoPairProduct._id
                )
                if (savedStyleNumber) {
                  this.infoPairProduct.styleNumber =
                    savedStyleNumber.styleNumber
                }
              }
              this.resetLoader()
            })
        }
        return promise
      })
      .then(response => {
        if (response && response.data) {
          this.infoPairProduct = response.data

          if (designData.styleNumbers) {
            let savedStyleNumber = designData.styleNumbers.find(
              x => x.id.toString() === this.infoPairProduct._id
            )
            if (savedStyleNumber) {
              this.infoPairProduct.styleNumber = savedStyleNumber.styleNumber
            }
          }
        }
        this.resetLoader()
      })
      .then(() => {
        if (!forceBuildPdf) {
          this.pdfLink = this._get(designData, 'pdfs.col')
        } else {
          this.pdfLink = null
        }
        const availableCreateColorUp = [
          // 'designPreview',
          // 'designOrder',
          'finalizeColorUpReview',
          'finalizeColorUpReviewOrder'
        ]
        if (
          !this.pdfLink &&
          availableCreateColorUp.includes(this.$route.name)
        ) {
          // generate color up if needed
          this.createColorUpPdf(true)
        } else {
          if (
            forceBuildPdf ||
            availableCreateColorUp.includes(this.$route.name)
          ) {
            //refreshing thumbs if them was already created
            this.designThumbnailsPDFCreated()
          }
        }
        return designData
      })
  }

  resetLoader() {
    if (!this.fromCustomizer) {
      setTimeout(() => {
        this.actionSetPreventHideLoader(false)
        this.actionSetPreventShowLoader(false)
        this.hideLoading()
      })
    }
  }

  setDimensions() {
    this.$nextTick(() => {
      if (this._has(this.$refs, 'headerButtons')) {
        const parentEl = this.$refs.headerButtons.parentElement
        const styleParent = window.getComputedStyle
          ? getComputedStyle(parentEl, null)
          : parentEl.currentStyle
        this.$refs.headerButtons.style.width = `${parentEl.offsetWidth -
          parseFloat(styleParent.paddingLeft) -
          parseFloat(styleParent.paddingRight)}px`
      }
    })
  }

  get mainProductProps() {
    const getterDesignData = this.getterDesignData

    return {
      id: this.id,
      data: {
        organizationName: this.organizationName,
        createdAt: this._get(this.getterDesignData, 'createdAt'),
        menuItemsProduct: this.menuItemsMainProduct,
        designName: this.designName && this.designName.toUpperCase()
      },
      thumbnails: {
        centerPath:
          getterDesignData.thumbnailCenterPathTop ||
          getterDesignData.thumbnailCenterPath,
        backPath:
          getterDesignData.thumbnailBackPathTop ||
          getterDesignData.thumbnailBackPath,
        sidePath:
          getterDesignData.thumbnailSidePathTop ||
          getterDesignData.thumbnailSidePath,
        rightPath:
          getterDesignData.thumbnailRightPathTop ||
          getterDesignData.thumbnailRightPath
      },
      infoProduct: this.infoMainProduct,
      stateMaterials: this.stateMaterials
    }
  }

  get pairProductProps() {
    const getterDesignData = this.getterDesignData

    return {
      id: this.id,
      data: {
        organizationName: this.organizationName,
        createdAt: this._get(this.getterDesignData, 'createdAt'),
        menuItemsProduct: this.menuItemsPairProduct,
        designName: this.designName && this.designName.toUpperCase()
      },
      thumbnails: {
        centerPath:
          getterDesignData.thumbnailCenterPathBottom ||
          getterDesignData.thumbnailCenterPath,
        backPath:
          getterDesignData.thumbnailBackPathBottom ||
          getterDesignData.thumbnailBackPath,
        sidePath:
          getterDesignData.thumbnailSidePathBottom ||
          getterDesignData.thumbnailSidePath,
        rightPath:
          getterDesignData.thumbnailRightPathBottom ||
          getterDesignData.thumbnailRightPath
      },
      infoProduct: this.infoPairProduct,
      stateMaterials: this.stateMaterials
    }
  }

  get hContentDesign() {
    return window.innerHeight
  }

  get organizationName() {
    return (
      this._get(
        this.getterDesignData,
        'userObj.organization.organizationName'
      ) ||
      this._get(this.currentUserDetail, 'organization.organizationName', '') ||
      ''
    )
  }

  get menuItemsMainProduct() {
    return (
      (this.getterDesignData &&
        Array.isArray(this.getterDesignData.menuItems) &&
        this.getterDesignData.menuItems.filter(
          menuItem =>
            menuItem.belongsToProductId === this.getterDesignData.product
        )) ||
      []
    )
  }

  get menuItemsPairProduct() {
    return (
      (this.getterDesignData &&
        Array.isArray(this.getterDesignData.menuItems) &&
        this.getterDesignData.menuItems.filter(
          menuItem =>
            menuItem.belongsToProductId !== this.getterDesignData.product
        )) ||
      []
    )
  }

  get hasPairProduct() {
    return (
      Array.isArray(this.menuItemsPairProduct) &&
      this.menuItemsPairProduct.length > 0
    )
  }

  onApprove() {
    const routeName = this.orderId ? 'orderSubmissionOrder' : 'orderSubmission'

    this.actionUpdateDesign({
      _id: this.id,
      status: {
        col: true
      },
      routeName: routeName
    }).then(() => {
      this.$router.push({
        name: routeName,
        params: { id: this.id }
      })
    })
  }

  downloadPDF() {
    // var opt = {
    //   margin: 1,
    //   filename: 'myfile.pdf',
    //   image: { type: 'jpeg', quality: 0.98 },
    //   html2canvas: { scale: 2 },
    //   jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    // }
    // console.log('******', this.$refs.viewPDFMainProduct.innerHTML)
    // // New Promise-based usage:
    // html2pdf()
    //   .from(this.$refs.viewPDFMainProduct.innerHTML)
    //   .set(opt)
    //   .save()
    // const doc = new JsPdf({
    //   orientation: 'landscape',
    //   // unit: 'in',
    //   format: 'letter'
    // })
    // // var doc = new JsPdf('l', 'pt', 'letter')
    // // this.doc.canvas.height = 11;
    // // this.doc.canvas.width = 8.5;
    // /** WITHOUT CSS */
    // // const contentHtml = this.$refs.viewPDF.innerHTML
    // this.doc.fromHTML(this.$refs.viewPDF, 0, 0, { width: 8.5 })
    // this.doc.save('colorupreview.pdf')
    // // this.doc.html(this.$refs.viewPDF, {
    // //   callback: function (doc) {
    // //     console.log('<<<PDF>>>', doc)
    // //     this.doc.save('colorupreview.pdf')
    // //   },
    // //   // html2canvas: {
    // //   //   height: 11,
    // //   //   width: 8.5
    // //   // }
    // // })
  }

  downloadPDFWithCSS(downloadable = true) {
    this.printPDF = true

    if (
      !this._get(this.$refs, 'viewPDFMainProduct') ||
      !this._get(this.$refs.viewPDFMainProduct, '$refs.rootElement')
    ) {
      return Promise.resolve(false)
    }
    this.showLoading()
    window.scrollTo(0, 0)

    const promise = new Promise((resolve, reject) => {
      this.$nextTick(() => {
        setTimeout(() => {
          this.doc = new JsPdf({
            orientation: 'landscape',
            unit: 'in',
            format: 'letter'
          })

          /** WITH CSS */
          const canvasElement = document.createElement('canvas')
          const configHtml2Canvas = {
            canvas: canvasElement,
            imageTimeout: 600000,
            logging: true,
            letterRendering: 1,
            allowTaint: true,
            useCORS: true,
            scrollX: 0,
            scrollY: 0,
            async: true
          }

          html2canvas(
            this.$refs.viewPDFMainProduct.$refs.rootElement,
            configHtml2Canvas
          ).then(canvas => {
            const img = canvas.toDataURL('image/jpeg', 1)
            // const proportion = this.$refs.mainProduct.clientWidth / this.$refs.mainProduct.clientHeight
            this.doc.addImage(img, 'JPEG', 0, 0, 11, 8.5)
            // this.doc.roundedRect(0.55, 0.4, 3, 3.7, 0, 0)
            this.doc.link(0.55, 0.4, 3, 3.7, {
              url:
                this.getterDesignData.thumbnailCenterPathTop ||
                this.getterDesignData.thumbnailCenterPath
            })

            // this.doc.roundedRect(0.55, 4.2, 3, 3.7, 0, 0)
            this.doc.link(0.55, 4.2, 3, 3.7, {
              url:
                this.getterDesignData.thumbnailBackPathTop ||
                this.getterDesignData.thumbnailBackPath
            })

            // this.doc.roundedRect(3.9, 2.15, 2.5, 4, 0, 0)
            this.doc.link(3.9, 0.4, 6.32, 3.7, {
              url:
                this.getterDesignData.thumbnailSidePathTop ||
                this.getterDesignData.thumbnailSidePath
            })

            this.doc.link(3.9, 4.2, 6.32, 3.7, {
              url:
                this.getterDesignData.thumbnailRightPathTop ||
                this.getterDesignData.thumbnailRightPath
            })

            if (this._has(this.$refs, 'viewPDFPairProduct')) {
              const canvasElement = document.createElement('canvas')
              html2canvas(
                this.$refs.viewPDFPairProduct.$refs.rootElement,
                configHtml2Canvas
              ).then(canvas => {
                const img = canvas.toDataURL('image/jpeg', 1)
                this.doc.addPage('letter', 'landscape')
                this.doc.addImage(img, 'JPEG', 0, 0, 11, 8.5)
                this.doc.link(0, 1, 2, 6, {
                  url:
                    this.getterDesignData.thumbnailCenterPathBottom ||
                    this.getterDesignData.thumbnailCenterPath
                })
                this.doc.link(2.2, 1, 2, 6, {
                  url:
                    this.getterDesignData.thumbnailSidePathBottom ||
                    this.getterDesignData.thumbnailSidePath
                })
                this.doc.link(4.4, 1, 2, 6, {
                  url:
                    this.getterDesignData.thumbnailBackPathBottom ||
                    this.getterDesignData.thumbnailBackPath
                })

                resolve(this.doc)

                if (downloadable) {
                  this.doc.save('colorupreview.pdf')
                  this.hideLoading()
                }
              })
            } else {
              resolve(this.doc)

              if (downloadable) {
                this.doc.save('colorupreview.pdf')
                this.hideLoading()
              }
            }

            this.printPDF = false
          })
        })
      })
    })

    return promise
  }
}
</script>

<style lang="scss" scoped>
.finalize-colorup-review {
  background-color: $white;

  @include colorup;

  &.customizer {
    padding-top: 50px;
  }
}
</style>
